/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import ApiService from 'cio/services/api';
import { dropTask } from 'ember-concurrency';
import AnalyticsService from 'cio/services/analytics';
import OAuthService from 'cio/services/oauth';
import { Provider } from 'cio/utils/oauth';

interface CredentialsConfigSlackArgs {
  onLoad?: () => unknown;
  onErrorLoading?: () => unknown;
  onEnable?: () => Promise<unknown>;
  onDisable?: () => Promise<unknown>;
}

export default class CredentialsConfigSlack extends Component<CredentialsConfigSlackArgs> {
  @service api!: ApiService;
  @service analytics!: AnalyticsService;
  @service oauth!: OAuthService;

  get onLoad() {
    return this.args.onLoad ?? (() => {});
  }

  get onErrorLoading() {
    return this.args.onErrorLoading ?? (() => {});
  }

  get onEnable() {
    return this.args.onEnable ?? (() => Promise.resolve());
  }

  get onDisable() {
    return this.args.onDisable ?? (() => Promise.resolve());
  }

  constructor(owner: unknown, args: CredentialsConfigSlackArgs) {
    super(owner, args);

    this.loadCredentialTask.perform();
  }

  loadCredentialTask = dropTask(async () => {
    try {
      let credential = await this.api.request('credentials/slack', {
        ignoreErrors: true,
        includeStatus: true,
      });
      this.onLoad();
      return credential;
    } catch (err) {
      if (err.status === '404') {
        this.onErrorLoading();
      }
    }
  });

  enableTask = dropTask(async () => {
    this.analytics.track('slack', 'enabling_started');
    let response = await this.oauth.open(Provider.Slack);

    await this.api.post('oauth2/slack', {
      data: {
        code: response.authorizationCode,
        redirect_uri: response.redirectUri,
      },
    });

    await this.loadCredentialTask.perform();
    return this.onEnable();
  });

  disableTask = dropTask(async () => {
    await this.api.delete('credentials/slack');

    await this.loadCredentialTask.perform();
    this.onDisable();
  });
}
